import React from 'react';
import { Icon } from '@iconify/react';
import {
  AppButton,
  AppEmptyState,
  AppFormField,
  AppInput,
  AppModal,
  AppSelect,
  AppSpinner,
} from '../../ui';
import MagazineMedia from './MagazineMedia';
import KoikispassDateLink from './KoikispassDateLink';
import { koikispassAgendaUrl } from './magazineHelpers';
import { resolveAgendaMediaUrl } from '../../../config/agendaApiConfig';

function KlubMagazineSetPickerModal({
  show,
  busy,
  candidateSearch,
  thematiqueId,
  dateFrom,
  dateTo,
  thematiques,
  selectedCandidateIds,
  filteredCandidates,
  onClose,
  onChangeSearch,
  onChangeThematique,
  onChangeDateFrom,
  onChangeDateTo,
  onToggleCandidate,
  onAddSelected,
}) {
  return (
    <AppModal
      show={show}
      title="Ajouter des dates"
      onClose={onClose}
      size="lg"
      scrollable
      footer={(
        <>
          <AppButton variant="outline-secondary" onClick={onClose}>Annuler</AppButton>
          <AppButton
            variant="primary"
            loading={busy}
            disabled={!selectedCandidateIds.length}
            onClick={onAddSelected}
          >
            Ajouter ({selectedCandidateIds.length})
          </AppButton>
        </>
      )}
    >
      <div className="row g-2 mb-3">
        <div className="col-md-6">
          <AppFormField label="Recherche" htmlFor="set-candidate-search" className="mb-0">
            <AppInput
              id="set-candidate-search"
              value={candidateSearch}
              onChange={(e) => onChangeSearch(e.target.value)}
              placeholder="Titre, lieu, commune…"
            />
          </AppFormField>
        </div>
        <div className="col-md-6">
          <AppFormField label="Thématique" htmlFor="set-candidate-theme" className="mb-0">
            <AppSelect
              id="set-candidate-theme"
              value={thematiqueId}
              onChange={(e) => onChangeThematique(e.target.value)}
            >
              <option value="">Toutes</option>
              {(thematiques ?? []).map((theme) => (
                <option key={theme.id} value={String(theme.id)}>{theme.nom}</option>
              ))}
            </AppSelect>
          </AppFormField>
        </div>
        <div className="col-md-6">
          <AppFormField label="Du" htmlFor="set-candidate-from" className="mb-0">
            <AppInput
              id="set-candidate-from"
              type="date"
              value={dateFrom}
              onChange={(e) => onChangeDateFrom(e.target.value)}
            />
          </AppFormField>
        </div>
        <div className="col-md-6">
          <AppFormField label="Au" htmlFor="set-candidate-to" className="mb-0">
            <AppInput
              id="set-candidate-to"
              type="date"
              value={dateTo}
              onChange={(e) => onChangeDateTo(e.target.value)}
            />
          </AppFormField>
        </div>
      </div>
      {filteredCandidates === null ? (
        <AppSpinner />
      ) : filteredCandidates.length === 0 ? (
        <AppEmptyState message="Aucune date disponible sur cette période." />
      ) : (
        <div className="klub-magazine-grid klub-magazine-picker-grid">
          {filteredCandidates.map((c) => {
            const selected = selectedCandidateIds.includes(c.id);
            return (
              <article
                key={c.id}
                className={`klub-magazine-card klub-magazine-card--selectable${selected ? ' is-selected' : ''}`}
              >
                <button
                  type="button"
                  className="klub-magazine-card__hit"
                  onClick={() => onToggleCandidate(c.id)}
                  aria-pressed={selected}
                >
                  <span className="klub-magazine-card__check" aria-hidden>
                    <Icon icon={selected ? 'mdi:check' : 'mdi:plus'} />
                  </span>
                  <div className="klub-magazine-card__media" title={c.image_path || undefined}>
                    <MagazineMedia
                      path={c.image_path}
                      resolveUrl={resolveAgendaMediaUrl}
                      fallbackIcon="mdi:calendar-month"
                      alt={c.titre || ''}
                    />
                  </div>
                  <div className="klub-magazine-card__body">
                    <p className="klub-magazine-card__title">{c.titre || '—'}</p>
                    <p className="klub-magazine-card__meta">{c.date_label || '—'}</p>
                    {c.thematique ? <p className="klub-magazine-card__meta">{c.thematique}</p> : null}
                    {c.lieu ? <p className="klub-magazine-card__meta">{c.lieu}</p> : null}
                  </div>
                </button>
                {koikispassAgendaUrl(c) ? (
                  <div className="klub-magazine-card__actions">
                    <KoikispassDateLink row={c} />
                  </div>
                ) : null}
              </article>
            );
          })}
        </div>
      )}
    </AppModal>
  );
}

export default KlubMagazineSetPickerModal;
